import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { notificationAPI } from 'api/NotificationAPI'
import ErrorOverlay from 'Components/General/ErrorOverlay'
import NotificationModal from 'Components/General/Toolbar/NotificationModal'
import LoadingIndicator from 'Components/reusable/LoadingIndicator'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { IError } from 'types/error'

/**
 * Renders the Unsubscribe component.
 *
 * @return {React.ReactElement} The rendered Unsubscribe component.
 * @notExported
 */
const Unsubscribe = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [backendError, setBackendError] = useState<IError>()
  const [loading, setLoading] = useState(true)

  // Get the token from the URL query parameters
  const { search } = window.location
  const params = new URLSearchParams(search)
  const token = params.get('token')

  useEffect(() => {
    const controller = new AbortController()

    if (token && token.length > 0) {
      ;(async () => {
        try {
          setLoading(true)
          await notificationAPI.setUnsubscribe(token, controller)
        } catch (error) {
          setBackendError(error as IError)
        } finally {
          setLoading(false)
        }
      })()
    }

    return () => {
      controller.abort()
    }
  }, [token])

  if (!token) {
    return (
      <Box p={{ md: 3, sm: 1, xs: 0 }} mt={{ xs: 1 }}>
        <NotificationModal onClose={() => navigate('/')} allowSubmit={t('save')} header={t('notificationSettings')} />
      </Box>
    )
  }

  if (backendError && backendError.name !== 'CanceledError' && backendError.name !== 'AbortError') {
    return <ErrorOverlay error={backendError} setOpen={setBackendError} disableContinue />
  }

  if (loading) {
    return <LoadingIndicator />
  } else {
    return (
      <Box p={{ md: 3, sm: 1, xs: 0 }} mt={{ xs: 1 }}>
        {!loading && <Typography variant="h6">{t('unsubscribedSuccessfully')}</Typography>}
      </Box>
    )
  }
}

export default Unsubscribe
